<template>
    <div class="card">
        <div class="card-image">
            <figure class="image is-5by3">
                <img
                    v-if="content.image"
                    loading="lazy"
                    :src="content.image.url"
                    :alt="content.title"
                    style="object-fit: cover"
                />
            </figure>
        </div>

        <div class="card-content">
            <div class="content">
                <p
                    v-if="isAdmin || isFacilitator"
                    v-t="
                        'Constants.PUBLISHED_' +
                        content.published.toString().toUpperCase()
                    "
                    :class="content.published ? 'is-primary' : 'is-warning'"
                    class="tag"
                ></p>
                <p
                    class="is-uppercase is-size-7 has-text-grey has-text-weight-bold mb-1"
                >
                    {{ content.mainTag }}
                </p>
                <!--div class="level">
          <div class="level-left">
        <div class="level-item"-->
                <p class="title is-5">
                    {{ content.title }}
                </p>
                <!--/div>
          </div>
        <div class="level-right">
            <div class="level-item">
              <button 
                aria-label="more options" 
                class="button is-white">
                <span class="icon has-text-grey">
                  <i
                    class="mdi mdi-24px mdi-dots-vertical"
                    aria-hidden="true"
                  />
                </span>
              </button>
            </div>
        </div>
        </div-->

                <p v-html="content.shortDescription"></p>
                <div class="tags">
                    <span
                        v-for="tag in groupedTags"
                        :key="tag.value"
                        :class="`lb-bain-tag-${tag.category}`"
                        >{{
                            $t(`Constants.BAIN_TAG_${tag.value.toUpperCase()}`)
                        }}</span
                    >
                </div>
            </div>
            <div class="has-text-centered">
                <!--TODO: register click from button-->
                <router-link
                    v-t="'Buttons.view_content'"
                    :to="{
                        name: 'activity',
                        params: { activityId: content._id },
                    }"
                    tag="a"
                    class="lb-button is-primary"
                ></router-link>
            </div>
        </div>
        <footer v-if="isAdmin" class="card-footer" @click.stop.prevent>
            <a
                v-t="'Buttons.edit'"
                class="card-footer-item"
                @click="$emit('edit')"
            ></a>
            <a
                v-t="
                    content.published ? 'Buttons.unpublish' : 'Buttons.publish'
                "
                class="card-footer-item"
                @click="$emit('toggleState')"
            ></a>
            <a
                v-t="'Buttons.delete'"
                class="card-footer-item has-text-danger"
                @click="$emit('delete')"
            ></a>
            <a class="card-footer-item dropdown is-hoverable">
                <span class="icon has-text-grey dropdown-trigger">
                    <i
                        class="mdi mdi-24px mdi-dots-vertical"
                        aria-hidden="true"
                    />
                </span>
                <div class="dropdown-menu" role="menu">
                    <div class="dropdown-content">
                        <div class="dropdown-item" @click="$emit('duplicate')">
                            <p v-t="'Buttons.duplicate'"></p>
                        </div>
                        <hr class="dropdown-divider" />
                        <div class="dropdown-item" @click="$emit('move')">
                            <p v-t="'Buttons.move_to'"></p>
                        </div>
                    </div>
                </div>
            </a>
        </footer>
    </div>
</template>

<script>
import _ from 'underscore';
import { BAIN_TAGS } from '@/lib/constants';
export default {
    props: {
        content: {
            type: Object,
            default() {
                return {};
            },
            required: true,
        },
    },
    computed: {
        groupedTags() {
            const presentTags = _.filter(BAIN_TAGS, (tagInfo) => {
                return _.contains(this.content.tags, tagInfo.value);
            });
            return _.flatten(
                _.chain(presentTags).groupBy('category').values().value()
            );
        },
        isAdmin() {
            return this.$store.getters.community.accessLevel == 'administrator';
        },
        isFacilitator() {
            return this.$store.getters.community.accessLevel == 'facilitator';
        },
    },
};
</script>
<style scoped>
.card-footers {
    border-top: unset;
}
</style>

<!--style scoped lang="sass">
@import "src/assets/sass/labygram-style"
.lb-activity-card
  @extend .has-shadow
  min-height: 234px
  width: 32rem
  position: relative
  border-radius: 0.25rem
  overflow: hidden
  text-overflow: ellipsis
  +until($desktop)
    height: auto
    width: auto
    margin-left: 0rem
    margin-right: 0rem
  +tablet
    width: 36rem
  +desktop
    width: 42rem
  +widescreen
    width: 56rem
.lb-community-course-image
  width: 317px
  position: relative
  top: 0
  +until($desktop)
    width: 100%
  img
    object-fit: cover
    width: 317px
    +until($desktop)
      width: 100%
.image
  width: 317px
  +until($desktop)
    width: 100%
.media
  +until($desktop)
    display: block
.media-content
  +until($desktop)
    padding: 1rem
</style-->
